import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage, 
    showSuccessMessage, 
    showWarningMessage,
    locationsActionTypes, 
    GET_MASTERDATABYNAME, 
    GET_LOCATIONS_LIST_API, 
    POST_LOCATIONS_API, 
    DELETE_LOCATIONS_API,
    GET_LOCATIONS_DETAIL_API
} from '../constants/ApiConstants';

import Alert from 'react-s-alert';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../../../actions/utilAction';
import { PatientRecordABCDataList } from '../../../../collectData/componnets/BehaviorData/actions/BehaviourDataActions';

export const getMasterData = (masterData) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(locationsActionTypes.get_masterData.REQUEST));
        fetch(`${GET_MASTERDATABYNAME}`, {
            method: 'post',
            body: JSON.stringify(masterData),
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
            .then(function (response) {
                dispatch(actionCreator(locationsActionTypes.get_masterData.SUCCESS, response));
            })
            .catch(function (error) {
                console.log('error getMasterData ..', error);
            });
    }; 
};

export const getLocationsList = (searchObj) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(locationsActionTypes.get_locationsList.REQUEST));
        fetch(`${GET_LOCATIONS_LIST_API}${query_params}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(locationsActionTypes.get_locationsList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(locationsActionTypes.get_locationsList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_locationsList', error);
            });
    };
};

export const getLocationsListDetails = (reductionId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(locationsActionTypes.get_locationsDetail.REQUEST));
        fetch(`${GET_LOCATIONS_DETAIL_API}?reductionId=${reductionId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(locationsActionTypes.get_locationsDetail.SUCCESS, response));
                } else {
                    dispatch(actionCreator(locationsActionTypes.get_locationsDetail.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_locationsDetail', error);
            });
    };
};

export const saveLocations = (formProps, patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(locationsActionTypes.save_locations.REQUEST));
        fetch(`${POST_LOCATIONS_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(locationsActionTypes.save_locations.SUCCESS, response));
                    dispatch(PatientRecordABCDataList(patientId))
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(locationsActionTypes.save_locations.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_locations', error);
            });
    };
};

export const deleteLocations = (reductionId) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(locationsActionTypes.delete_locations.REQUEST));
        fetch(`${DELETE_LOCATIONS_API}?reductionId=${reductionId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(locationsActionTypes.delete_locations.SUCCESS, response));
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(locationsActionTypes.delete_locations.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(locationsActionTypes.delete_locations.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_locations', error);
            });
    };
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Locations/actions/locationsActions.js